module.exports = __webpack_public_path__ + "1791188489487/images/40px.1f07573.png";